import { Component } from '@angular/core';
import { ModalBase } from '../../base/modal-base/modal-base.component';

@Component({
    selector: 'uninstall-donation-modal',
    templateUrl: 'uninstall-donation.modal.html',
    standalone: false,
})
export class UninstallDonationModal extends ModalBase {
    public openModal(): void {
        this.open();
    }

    public get modalId(): string {
        return 'uninstall-donation-modal';
    }

    public ngAfterViewInit(): void {
        this.init();
    }
}
